<template>
   <div v-if="notification.isVisible" :class="`alert alert-${notification.type} fixed-top notification-popup`">
    <i class="fa fa-info-circle me-2"></i>
    <span>{{ notification.message }}</span>
  </div>
  <div class="d-flex justify-content-center spinner-border text-primary spinner-position" v-if="page.isLoading"></div>
  <div class="spinner" v-if='page.isLoading'></div>
  <div class="container" v-if="thisComponentShow">
    <div class="custom-breadcrumb">
      <o-bread-crumb>
        <template v-slot:pageName>
          Tax & Service
        </template>
        <template v-slot:pageDescription>
          <!-- This page allows you to manage Tax & Service policies that will apply to all branches and merchants under this entity, and will affect point calculations for all members during transactions. -->
        </template>
      </o-bread-crumb>
    </div>

    <div class="mt-4" style="max-width: 500px;">
      <div class="tax-toggle-card d-flex flex-column align-items-start bg-white p-4 shadow">
        <div class="section-description mb-3">
          <p>This section allows you to manage Tax & Service policies that will apply to all branches and merchants under this entity, 
              and will affect point calculations for all members during transactions.</p>
        </div>
        <o-form-group name="taxMode" title="">
          <div class="switch-box d-flex align-items-center">
            <span class="me-2 fw-bold" :class="{ active: tax_service_type === 'exclude' }">Exclude</span>
            <label class="switch">
              <input type="checkbox" v-model="tax_service_type" true-value="include" false-value="exclude">
              <span class="slider round"></span>
            </label>
            <span class="ms-2 fw-bold" :class="{ active: tax_service_type === 'include' }">Include</span>
          </div>
        </o-form-group>

        <div class="form-area mt-3 w-100">
          <o-form-group name="tax" title="Tax (%)">
            <o-input-text v-model="tax" type="number" placeholder="Enter tax %" />
            <div v-if="validation.tax">
                <div class="alert alert-danger mt-1" role="alert">
                    {{ validation.tax[0] }}
                </div>
            </div>
          </o-form-group>

          <o-form-group name="service" title="Service (%)">
            <o-input-text v-model="service" type="number" placeholder="Enter service %" />
            <div v-if="validation.service">
                <div class="alert alert-danger mt-1" role="alert">
                    {{ validation.service[0] }}
                </div>
            </div>
          </o-form-group>

          <div class="mt-3">
            <o-button v-if="write" variant="primary" :white="'white'" class="w-100" @click="saveTaxService">
              Apply
            </o-button>
          </div>
        </div>
      </div>
    </div>

    <div class="tax-before-after mt-4" style="max-width: 500px;" v-if="showBeforeAfterTax">
      <div class="tax-toggle-card d-flex flex-column align-items-start bg-white p-4 shadow">
        <div class="section-description mb-3">
          <p>This section is used to configure how points are calculated for transactions that occur outside the membership apps, specifically whether tax should be included or excluded in the calculation.</p>
        </div>

        <o-form-group name="taxBeforeAfter" title="">
          <div class="switch-box d-flex align-items-center">
            <span class="me-2 fw-bold" :class="{ active: beforeAfterTax === 'before' }">Before Tax</span>
            <label class="switch">
              <input type="checkbox" v-model="beforeAfterTax" true-value="after" false-value="before" @change="saveTaxServiceBeforeAfter"/>
              <span class="slider round"></span>
            </label>
            <span class="ms-2 fw-bold" :class="{ active: beforeAfterTax === 'after' }">After Tax</span>
          </div>
        </o-form-group>
      </div>
    </div>
  </div>
  <div v-else class="container mt-4">
    <div class="alert alert-danger" role="alert">
      {{ validation }}
    </div>
  </div>
</template>

<script>
import { OFormGroup, OInputText, OButton, OBreadCrumb } from '@/components/OmnihControl';
import { reactive, ref } from '@vue/reactivity';
import { onMounted } from '@vue/runtime-core';
import { useStore } from 'vuex';
import { watch } from 'vue';

export default {
  components: {
    OBreadCrumb,
    OFormGroup,
    OInputText,
    OButton
  },
  setup() {
    const store = useStore();
    const tax_service_type = ref('include');
    const tax = ref('');
    const service = ref('');
    const beforeAfterTax = ref('before');
    const taxServiceApps = ref({
      id: null,
      tax: '',
      service: '',
      tax_service_type: ''
    });
    let page = reactive({
        isLoading: false,
        output: false,
        component: 'tax-service'
    });
    const validation = ref([]);
    const thisComponentShow = ref(true);
    const selfLoaded = ref(store.state.Auth.selfLoaded);
    const selectedBusinessProfile = reactive({
      corporate_id: null,
      branch_id: null,
      merchant_id: null
    });
    const taxServiceId = ref(null);
    const alertType = ref('success');
    const showValidation = ref(false);
    const write = ref(false);
    const isRoot = ref(false);
    const showBeforeAfterTax = ref(false);
    const notification = ref({
      message: '',
      type: '',
      isVisible: false
    });

    watch(
      [() => store.state.Auth.selfLoaded, () => store.state.Auth.userInfo.modules],
      async ([selfLoadedVal, modules]) => {
        if (selfLoadedVal && modules && Array.isArray(modules)) {
          selfLoaded.value = selfLoadedVal;

          const businessProfile = await store.dispatch('Auth/getBusinessProfile');
          selectedBusinessProfile.corporate_id = businessProfile.corporate_id;
          selectedBusinessProfile.branch_id = businessProfile.branch_id;
          selectedBusinessProfile.merchant_id = businessProfile.merchant_id;

          showBeforeAfterTax.value = selectedBusinessProfile.corporate_id && !selectedBusinessProfile.branch_id && !selectedBusinessProfile.merchant_id;
          loadTaxServiceData();
        }

        const level = store.state.Auth.currUser.level;

        if (level === 'root') {
          write.value = true;
          isRoot.value = true;
        }
      },
      { immediate: true }
    );

    // watch(beforeAfterTax, () => {
    //   saveTaxServiceBeforeAfter();
    // });

    // watch(tax_service_type, (newVal, oldVal) => {
    //   showValidation.value = false;
    //   if ((oldVal === '' || oldVal === 'exclude') && newVal === 'include') {
    //     saveTaxService();
    //   }
    // });


    onMounted(async () => {
      try {
        page.isLoading = true;
        const businessProfile = await store.dispatch('Auth/getBusinessProfile');
        selectedBusinessProfile.corporate_id = businessProfile.corporate_id;
        selectedBusinessProfile.branch_id = businessProfile.branch_id;
        selectedBusinessProfile.merchant_id = businessProfile.merchant_id;
        showBeforeAfterTax.value = selectedBusinessProfile.corporate_id && !selectedBusinessProfile.branch_id && !selectedBusinessProfile.merchant_id;

        loadTaxServiceData();
      } catch (err) {
        console.error(err);
        validation.value = 'Failed to load business profile';
      } finally {
        page.isLoading = false;
      }
    });

    const loadTaxServiceData = () => {
      page.isLoading = true;
      
      try {
        const id = determineEntityId(); // Tentukan ID entitas (merchant, branch, corporate)
        if (!id) {
          throw new Error('Unable to determine entity (merchant/branch/corporate)');
        }

        // Memuat data TaxService dan TaxServiceApps secara bersamaan
        Promise.all([
          store.dispatch('TaxService/read_single', id),  // Ambil data TaxService
          store.dispatch('TaxService/read_single_apps', id)  // Ambil data TaxServiceApps
        ])
        .then(([taxServiceRes, taxServiceAppsRes]) => {
          // Handle hasil untuk TaxService
          const level = store.state.Auth.currUser.level;
          const userModules = store.state.Auth.userInfo.modules;
          
          if (level === 'root') {
            write.value = true;
            isRoot.value = true;
          } else {
            const module = userModules.find(mod => mod.module_name === page.component);
            write.value = module?.write === true || module?.write === 1;
          }

          if (taxServiceRes && taxServiceRes.original && taxServiceRes.original.message) {
            if (taxServiceRes.original.error_code && taxServiceRes.original.error_code === "TAX_SERVICE.NOT_FOUND") {
              // showNotification(taxServiceRes?.original?.message, 'danger');
              return;
            } else {
              return;
              // showNotification(taxServiceRes?.original?.message, 'success');
            }
          }
          if (!taxServiceRes || typeof taxServiceRes !== 'object' || Object.keys(taxServiceRes).length === 0) {
            return;
          }

          const taxData = taxServiceRes;
          taxServiceId.value = taxData.id || null;
          tax.value = taxData.tax ?? '';
          service.value = taxData.service ?? '';
          tax_service_type.value = taxData.tax_service_type === 'exclude' ? 'exclude' : 'include';
          alertType.value = 'success';
          validation.value = '';
          showValidation.value = false;

          // Handle hasil untuk TaxServiceApps
          if (!taxServiceAppsRes || typeof taxServiceAppsRes !== 'object' || Object.keys(taxServiceAppsRes).length === 0) {
            return;
          }

          const taxServiceAppsData = taxServiceAppsRes;
          taxServiceApps.value.id = taxServiceAppsData.id || null;
          taxServiceApps.value.tax = taxServiceAppsData.tax ?? '';
          taxServiceApps.value.service = taxServiceAppsData.service ?? '';
          taxServiceApps.value.tax_service_type = taxServiceAppsData.type ?? '';
          beforeAfterTax.value = taxServiceAppsData.type === 'after' ? 'after' : 'before';
        })
        .catch(err => {
          validation.value = err?.response?.data?.error ?? err?.response?.data?.message ?? err?.message;
          thisComponentShow.value = false;
          alertType.value = 'danger';
        })
        .finally(() => {
          page.isLoading = false;
        });
      } catch (err) {
        validation.value = err?.response?.data?.error ?? err?.response?.data?.message ?? err.message ?? 'Access validation failed';
        thisComponentShow.value = false;
        page.isLoading = false;
      }
    };


    const determineEntityId = () => {
      return selectedBusinessProfile.merchant_id || selectedBusinessProfile.branch_id || selectedBusinessProfile.corporate_id || null;
    };

    const resolveTaxableType = () => {
      if (selectedBusinessProfile.merchant_id) return 'App\\Models\\Merchant';
      if (selectedBusinessProfile.branch_id) return 'App\\Models\\Branch';
      if (selectedBusinessProfile.corporate_id) return 'App\\Models\\Corporate';
      return null;
    };

    const saveTaxService = () => {
      const entityId = determineEntityId();
      if (!entityId) return;

      page.isLoading = true;
      showValidation.value = false;

      const taxValue = tax.value;
      const serviceValue = service.value;
      const taxableType = resolveTaxableType();
      const payload = {
        taxable_id: entityId,
        taxable_type: taxableType,
        tax_service_type: tax_service_type.value,
        tax: taxValue,
        service: serviceValue
      };

      const action = taxServiceId.value
        ? store.dispatch('TaxService/update', { data: { ...payload, id: taxServiceId.value } })
        : store.dispatch('TaxService/create', { data: payload });

      action.then((response) => {
          showNotification(response?.data?.data?.message, 'success');
          validation.value = response?.data?.data?.message;
          const data = response?.data?.data?.data;
          
          if (data == null) {
            showNotification(response?.data?.data?.message, 'success');
            alertType.value = 'success';
            showValidation.value = true;
            tax_service_type.value = 'include';
          }else if(data !== null){
            taxServiceId.value = data.id || null;
            tax.value = data.tax;
            service.value = data.service;
            alertType.value = 'success';
            showValidation.value = true;
          }
        })
        .catch(err => {
          let errorMessage = err.response?.data?.error || err.response?.data?.message || 'Failed to save Tax Service';

          let parsedError = errorMessage;
          let isJsonError = false;

          if (err.response?.data?.error && typeof err.response.data.error === 'string') {
            try {
              parsedError = JSON.parse(err.response.data.error);
              if (typeof parsedError === 'object') {
                isJsonError = true;
              }
            } catch (e) {
              parsedError = errorMessage;
            }
          }

          validation.value = parsedError;
          if (!isJsonError) {
            if (err.response?.data?.error && err.response?.data?.message == 'TAXSERVICE.CREATE.VALIDATION_ERROR_USING' ) {
              showNotification(errorMessage, 'success');
            } else {
              showNotification(errorMessage, 'danger');
            }
          }

          if (typeof errorMessage === 'string' && errorMessage.includes('Warning - Tax + Service can’t be above 100%')) {
            alertType.value = 'warning';
          } else {
            alertType.value = 'danger';
          }

          showValidation.value = true;
          page.isLoading = false;
        })
        .finally(() => {
          page.isLoading = false;
        });
    };

    const saveTaxServiceBeforeAfter = () => {
      if (!selectedBusinessProfile.corporate_id) {
        return;
      }

      if (!showBeforeAfterTax.value) return;

      page.isLoading = true;
      showValidation.value = false;

      const taxableType = resolveTaxableType();

      const payload = {
        taxable_id: selectedBusinessProfile.corporate_id, // Always use corporate_id
        taxable_type: taxableType,
        type: beforeAfterTax.value
      };

      const action = taxServiceApps.value.id
        ? store.dispatch('TaxService/updateApps', { data: { ...payload, id: taxServiceApps.value.id } })
        : store.dispatch('TaxService/createApps', { data: payload });

      action.then((response) => {
        showNotification(response?.data?.data?.message, 'success');
        validation.value = response?.data?.data?.message;
        const data = response?.data?.data?.data;

        taxServiceApps.value.id = data.id || null;
        beforeAfterTax.value = data.type ?? '';

        alertType.value = 'success';
        showValidation.value = true;
        page.isLoading = false;
      })
      .catch(err => {
        const errorMessage = err.response?.data?.error || err.response?.data?.message || 'Failed to save Tax Service Before/After';
        showNotification(errorMessage, 'danger');
        validation.value = errorMessage;

        if (errorMessage.includes('Warning - Tax + Service can’t be above 100%')) {
          alertType.value = 'warning';
        } else {
          alertType.value = 'danger';
        }

        showValidation.value = true;
        page.isLoading = false;
      })
      .finally(() => {
        page.isLoading = false;
      });
    };

    const showNotification = (message, type) => {
      notification.value.message = message;
      notification.value.type = type;
      notification.value.isVisible = true;
      setTimeout(() => {
        notification.value.isVisible = false;
      }, 5000);
    };

    return {
      page,
      tax_service_type,
      tax,
      service,
      saveTaxService,
      validation,
      alertType,
      showValidation,
      thisComponentShow,
      write,
      isRoot,
      beforeAfterTax,
      taxServiceApps,
      showBeforeAfterTax,
      notification,
      saveTaxServiceBeforeAfter
    };
  }
};
</script>

<style scoped>
.tax-toggle-card {
  width: 350%;
  max-width: 842px;
  margin-left: 0;
  margin-right: auto;
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: border-radius 0.3s ease;
}

.switch-box {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}

.switch-box span {
  font-size: 15px;
  color: #555;
  transition: all 0.3s ease;
  font-weight: 600;
}

.switch-box span.active {
  color: #000;
}

.switch {
  position: relative;
  display: inline-block;
  width: 48px;
  height: 24px;
  margin: 0 12px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  inset: 0;
  background-color: #484b49;
  transition: 0.4s;
  border-radius: 24px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: var(--primary-color, #dc3545);
}

input:checked + .slider:before {
  transform: translateX(24px);
}

@media (max-width: 768px) {
  .tax-toggle-card {
    max-width: 100%; 
    margin-left: 10px;
    margin-right: 10px;
  }
  
  .switch-box {
    font-size: 14px;
  }
}
.section-description {
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.5);
}

.notification-popup {
  width: 100%;
  max-width: 400px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 8px;
  z-index: 9999;
  margin-top: 10px;
}
</style>
